module.exports = __webpack_public_path__ + "static/media/defentex.3a6c6303.jpg";